import { render, staticRenderFns } from "./TypeGrammar.vue?vue&type=template&id=5e11d269&"
import script from "./TypeGrammar.vue?vue&type=script&lang=js&"
export * from "./TypeGrammar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports